import ClientService from '../../../services/client-service';
import getDealTaskListDataQuery from '../../../graphql/query/get-deal-task-list-data.graphql';
import deleteDealTaskListMutation from '../../../graphql/mutation/delete-deal-task-list.graphql';
import deleteDealTaskGroupMutation from '../../../graphql/mutation/delete-deal-task-group.graphql';
import deleteDealTaskCommentMutation from '../../../graphql/mutation/delete-deal-task-comment.graphql';
import saveDealTaskMutation from '../../../graphql/mutation/save-deal-task.graphql';
import saveDealTaskStatusMutation from '../../../graphql/mutation/save-deal-task-status.graphql';
import saveDealTaskReviewStatusMutation from '../../../graphql/mutation/save-deal-task-review-status.graphql';
import saveDealTaskTemplateDataMutation from '../../../graphql/mutation/save-deal-task-template-data.graphql';
import loadDealTaskTemplateDataMutation from '../../../graphql/mutation/load-deal-task-template-data.graphql';
import saveDealTaskCommentMutation from '../../../graphql/mutation/save-deal-task-comment.graphql';
import saveDealTaskListMutation from '../../../graphql/mutation/save-deal-task-list.graphql';
import saveDealTaskGroupOrderSettingsMutation
  from '../../../graphql/mutation/save-deal-task-group-order-settings.graphql';

export default class DealTasksApi {
  public static getDealTaskListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealTaskListDataQuery, payload);
  }

  public static deleteDealTaskList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealTaskListMutation, payload);
  }

  public static deleteDealTaskGroup(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealTaskGroupMutation, payload);
  }

  public static deleteDealTaskComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealTaskCommentMutation, payload);
  }

  public static saveDealTask(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTaskMutation, payload);
  }

  public static saveDealTaskStatus(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTaskStatusMutation, payload);
  }

  public static saveDealTaskReviewStatus(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTaskReviewStatusMutation, payload);
  }

  public static saveDealTaskTemplateData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTaskTemplateDataMutation, payload);
  }

  public static loadDealTaskTemplateData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(loadDealTaskTemplateDataMutation, payload);
  }

  public static saveDealTaskComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTaskCommentMutation, payload);
  }

  public static saveDealTaskList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTaskListMutation, payload);
  }

  public static saveDealTaskGroupOrderSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTaskGroupOrderSettingsMutation, payload);
  }
}
